import enLocale from 'element-ui/lib/locale/lang/en'
export default {
    ...enLocale,
    // 全局策略
    tabs: {
        regex: 'Regex',
        ipw: 'White IP',
        ipw1: 'White List',
        white_list: 'White List',

        ipb: 'Black IP',
        ipb1: 'Black List',
        fromw: 'White Sender',
        fromb: 'Black Sender',
        urlw: 'White URL',
        urlb: 'Black URL',
        regexw: 'white regex',
        avoid: 'avoid forge list',
        Recipient: 'Recipient blacklist',
        send_email: 'Recipient whitelist',
        categories: 'Different Categories',

    },
    table1: {
        export_email: 'derived record',
        // 1
        order: 'Order',
        type: 'Type',
        score: 'Score',
        header: 'Header key',
        rule: 'Regex Rule',
        policy: 'Policy type',
        operation: 'operation',
        addrule: 'Add Regex Rule',
        addrule1: 'Edit Regex Rule',
        ditt: 'edit',
        verify: 'verify',
        delete: 'delete',
        save: 'save',

        // 2
        ipAddress: 'ip address',
        expire: 'expire',
        description: 'description',
        addwip: 'Add white IP',
        impwip: 'Import white IP',
        expwip: 'Export white IP',
        // 3
        addbip: 'Add black IP',
        impbip: 'Import black IP',
        expbip: 'Export black IP',
        // 4
        yuming: 'domain or email address',
        addws: 'Add white Sender',
        impws: 'Import white Sender',
        expws: 'Export white Sender',
        // 5

        addbs: 'Add black Sender',
        impbs: 'Import black Sender',
        expbs: 'Export black Sender',
        // 6
        url: 'URL',
        addub: 'Add Url Blacklist',
        // 7
        adduw: 'Add Url Whitelist',
        // 8
        addwcr: 'Add white content regex',
        addwcr_edit: 'Edit white content regex',
        // 9
        forge: 'forge name',
        addnamef: 'Add name not to be forged',
        addfs: 'Add forge subject',
        upnf: 'Upload name file',
        // 10
        addbr: 'Add black recipient',
        impbr: 'Import black recipient',
        expbr: 'Export black recipient',
        addrecws: 'Add white recipient',
        imprecws: 'Import white recipient',
        exprecws: 'Export white recipient',

    },
    anti_gs1: {
        // 1
        User_type: 'User type',
        Score: 'Score',
        Headerkey: 'Header key',

        RegexRule: 'Regex Rule',
        Policytype: 'Policy type',
        // 2
        ipaddress: 'ip address',
        into_local: 'Join Local Network(VIP)',
        into_local1: 'Whether the VIP',

        // 4
        doemailaddress: 'domain or email ',
        // 6
        BlackURL: 'Black URL',
        //7
        WhiteURL: 'White URL',
        AddTag: 'Add Tag',
    },
    anti_gs1_tan: {
        del: 'really delete?',
        del1: 'successfully delete',
        del2: 'undelete',
        del3: 'successfully added',
        del4: 'Without data, return to the list',
        down_load: "Pack the selected messages and download them?",
        down_load_cancel: "Download cancelled",
        pass_email: "Are release emails confirmed?",
        pass_email_cancel: "Release cancelled",
        save_sueecss: 'save sueecss',
        save_sueecss3: 'report sueecss',
        save_sueecss1: 'update successfully',
        save_sueecss2: 'Data loading completed',
        rsync_sueecss: 'rsync_sueecss',
        select_time: 'Please select the set time',
        auth_sueecss: 'auth_sueecss',
        cancel_send1: 'Are you sure to do something about this message?',
        cancel_send2: 'Cancel the success',
        immediate_delivery: 'delivering successful',
        message_load: 'Parsing the message, please be patient',
        save_load: 'Save, please wait...',
        search_load: 'Search, please wait...',

        keyword: 'The keyword option cannot be empty',
        check_list: 'Please check at least one item before proceeding',
        delivery_again: 'again delivery',
        delivery_again_hint: 'Are you sure to redeliver this mail?',
        move_up: 'Move up?',
        down_up: 'Move down?',
        sure_will: 'sure will',
        sure_will_false: 'canceled',
    }

}